<template>
  <div class="text-hireful relative border-2 rounded-lg focus-within:border-hireful flex items-center justify-center flex-wrap w-full" v-click-outside="onClickOutside">
  <input type="search" autocomplete="off" id="autoCompleteInput" class="block appearance-none focus:outline-none bg-transparent w-full py-2 mx-2" v-model="searchText" :placeholder="label" @keydown="showSearchResult" @click="showSearchResult" :style="dropDownArrowStyle" />
    <transition name="fade">
       <div class="absolute w-full shadow leading-tight focus:outline-none focus:shadow-outline z-50 boxShadow3x" v-if="showResult"
      :class="{'mt-64': atsList.length >= 3, 'mt-48': atsList.length === 2, 'mt-24': atsList.length <= 1}">
        <div class="max-h-96 overflow-auto shadow-2xl" v-if="atsList.length">
          <template v-for="ats in atsList">
            <div :key="`ats-${ats.ats_id}`" @click="selectItem(ats)" class="px-4 py-2 border-b flex w-full justify-start cursor-pointer hover:bg-gray-200 bg-white">
              <div class="flex flex-wrap text-hireful">
                <div class="flex w-full text-base hireful-font-semibold text-left font-bold">
                  {{ats.organisation_name}}
                </div>
                <div class="flex w-full text-xs italics text-hireful" v-if="getCompanyTypeText(ats.company_type)">
                  {{getCompanyTypeText(ats.company_type)}}
                </div>
                <div class="flex w-full text-xs" v-if="ats.agency_admin_user">
                  {{ats.agency_admin_user.first_name}} {{ats.agency_admin_user.last_name}}
                </div>
                <div class="flex w-full text-xs text-hireful">
                  {{ats.role_type}}
                </div>
              </div>
            </div>
          </template>
          <div class="px-4 py-2 flex w-full justify-center cursor-pointer hover:bg-gray-200 bg-white text-hireful" v-if="showLoader">
          <loader />
        </div>
          <div class="px-4 py-2  flex w-full justify-center cursor-pointer hover:bg-gray-200 bg-white text-hireful" @click="searchaccessibleATSList(true)"
          v-if="showResultsButton">
            Show more results
          </div>
        </div>
        <div class="px-4 py-2 mt-5 flex w-full justify-center  bg-white text-hireful" v-if="!atsList.length && searchText.length > 3">
          No result found
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from 'axios'
import store from '@/store'

import vClickOutside from 'v-click-outside'
import loader from '@/components/loader'
import { unionBy, isEmpty } from 'lodash'

export default {
  name: 'autocompleteTechUser',
  directives: {
    clickOutside: vClickOutside.directive
  },
  components: {
    loader
  },
  props: {
    options: {
      type: Array,
      default: () => []
    },
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    label: {
      type: String,
      default: 'Search'
    }
  },
  data () {
    return {
      searchText: '',
      showResult: false,
      pageOffset: 0,
      pageLimit: 20,
      atsList: [],
      searchAts: true,
      showLoader: false,
      showResultsButton: true
    }
  },
  computed: {
    dropDownArrowStyle () {
      return { background: 'url(' + require('@/assets/images/icons/arrow_drop_down.png') + ') no-repeat right', backgroundSize: '32px' }
    }
  },
  watch: {
    showResult (val) {
      this.$emit('active', val)
    },
    searchText (val) {
      this.pageOffset = 0
      this.atsList = []
      if (val.length >= 3) {
        this.searchaccessibleATSList()
      }
    }
  },
  methods: {
    selectItem (item) {
      this.searchText = item.organisation_name
      this.$emit('selected', item)
      this.showResult = false
      this.searchAts = false
    },
    showSearchResult () {
      this.showResult = true
    },
    onClickOutside () {
      this.showResult = false
    },
    async searchaccessibleATSList (flag) {
      const vm = this
      vm.showLoader = true
      vm.showResultsButton = true
      if (flag) {
        vm.pageOffset = vm.pageLimit + vm.pageOffset
      }
      const withCredentialsConfig = {
        method: 'GET'
      }
      const resp = await axios(`${process.env.VUE_APP_LOGIN_API_HOST}${store.state.routes.searchClientList}?text=${vm.searchText}&limit=${vm.pageLimit}&offset=${vm.pageOffset}`, withCredentialsConfig)
      const list = resp.data.atsList
      if (isEmpty(list) || list.length < 20) {
        vm.showResultsButton = false
      }
      const atsList = unionBy(vm.atsList, list, 'ats_id')
      vm.atsList = atsList.sort((a, b) => a.organisation_name.localeCompare(b.organisation_name))
      if (vm.searchAts) {
        vm.showResult = true
        vm.searchAts = true
      }
      vm.showLoader = false
    }
  }
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s cubic-bezier(.06,.92,.62,.86);
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

#autoCompleteInput::-webkit-search-cancel-button{
    position:relative;
    right:25px;
}

::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  font-size: 0.75rem;
}
::-moz-placeholder { /* Firefox 19+ */
  font-size: 0.75rem;
}
:-ms-input-placeholder { /* IE 10+ */
  font-size: 0.75rem;
}
:-moz-placeholder { /* Firefox 18- */
  font-size: 0.75rem;
}

</style>
